import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'app-loader-overlay',
  imports: [],
  templateUrl: './loader-overlay.component.html',
  styleUrl: './loader-overlay.component.css'
})
export class LoaderOverlayComponent implements OnInit, OnDestroy {
  @Input() loadingMessage = 'Loading, please wait…';
  @Input() loadedMessage = 'Loading complete.';

  private liveAnnouncer = inject(LiveAnnouncer);

  ngOnInit(): void {
    this.liveAnnouncer.announce(this.loadingMessage, 'polite');
  }

  ngOnDestroy(): void {
    this.liveAnnouncer.announce(this.loadedMessage, 'polite');
  }
}
